// Minimal cookie helper — replaces the js-cookie library (former cookie.js).
// Loaded early in <head> (see layout/theme.liquid) so it's available before
// any inline section <script> that reads/writes a cookie on render.

function getCookie(name) {
	var nameEQ = encodeURIComponent(name) + '=';
	var cookies = document.cookie.split(';');

	for (var i = 0; i < cookies.length; i++) {
		var cookie = cookies[i].trim();

		if (cookie.indexOf(nameEQ) === 0) {
			return decodeURIComponent(cookie.substring(nameEQ.length));
		}
	}

	return null;
}

function setCookie(name, value, days) {
	var expires = '';

	if (value !== null && typeof value === 'object') {
		value = JSON.stringify(value);
	}

	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toUTCString();
	}

	document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/';
}
